import { getUserLocale } from "@/services/locale";

export const getData = async (dataFor: string) => {
  const locale = await getUserLocale();

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/${dataFor}`,
    {
      method: "GET",
      headers: {
        "Accept-Language": locale,
      },
      next: { revalidate: 1209600 }, // EVERY 2 WEEKS
    }
  ).then((res) => res.json());
  return response.data[dataFor];
};

export const clearError = (
  setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>,
  field: string
) =>
  setErrors((prev) => {
    const next = { ...prev };
    delete next[field];
    return next;
  });

export const prepareFilterToApi = (
  filter: Partial<Record<string, string | string[]>>
) => {
  let preparedFilter = "";

  for (const key in filter) {
    if (filter[key]) {
      preparedFilter += `&${key}=${filter[key]}`;
    }
  }

  return preparedFilter;
};

export type TSearchParams = Record<string, string> | undefined;

export const getParams = (sp: TSearchParams, key: string) => {
  const v = sp?.[key];
  return Array.isArray(v) ? v.join(",") : v ?? "";
};

export const formatDate = (date: string) => new Date(date).toLocaleDateString();

export const getPluralSuffix = (count: number) => (count > 1 ? "s" : "");
